import { isPaid, OwnedInvestment, ProjectStatus } from 'api-client';
import { Money as MoneyModel } from 'api-client';

import { formatEntryDate, formatProjectExternalId, formatRoiIrr } from './packageUtils';

export type MainAccountInvestmentRow = {
  key: string;
  name: string;
  projectId: string;
  status: ProjectStatus;
  entryDate: string;
  invested: MoneyModel;
  returned: MoneyModel | null;
  forecastReturn: MoneyModel | null;
  roiIrr: string;
};

const getEarliestInvestmentDate = (investment: OwnedInvestment): string | undefined => {
  if (investment.investments.length === 0) {
    return undefined;
  }

  const sorted = [...investment.investments].sort(
    (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
  );
  return String(sorted[0].createdAt);
};

const formatOwnedInvestmentRoiIrr = (investment: OwnedInvestment): string => {
  const { project } = investment;

  if (isPaid(project.status)) {
    return formatRoiIrr(project.factROI, project.factInterestRate);
  }

  return formatRoiIrr(project.simpleInterestRate, project.interestRate);
};

export const mapOwnedInvestmentToRow = (investment: OwnedInvestment): MainAccountInvestmentRow => ({
  key: investment.project.uuid,
  name: investment.project.name[0]?.text ?? '—',
  projectId: formatProjectExternalId(investment.project.paymentCode ?? investment.project.uuid),
  status: investment.project.status,
  entryDate: formatEntryDate(getEarliestInvestmentDate(investment)),
  invested: investment.investedSum,
  returned:
    investment.actualPayment && investment.actualPayment.amount !== 0
      ? investment.actualPayment
      : null,
  forecastReturn:
    investment.recoveryForecast && investment.recoveryForecast.amount !== 0
      ? investment.recoveryForecast
      : null,
  roiIrr: formatOwnedInvestmentRoiIrr(investment),
});
